const dict = {
  chooseLang: "Dil Seçin",
  agree: "Kabul Et",

  //Licence
  instructions: "Talimatlar",
  step1: "Adım 1: QR Kodu Tarayın",
  locateqr: "Sağınızdaki QR kodu bulun.",
  useSmartphone:
    "Taramak için akıllı telefonunuzun kamerasını veya bir QR kod tarayıcı uygulamasını kullanın. Bu sizi bir sonraki adıma götürecektir.",
  step2: "Adım 2: Oynatma Listesi Bilgilerini Girin",
  afterScan: "QR kodu taradıktan sonra oynatma listesi bilgilerinizi girmeniz istenecektir.",
  makeSure: "Tüm gerekli alanları doldurduğunuzdan emin olun.",
  step3: "Adım 3: Uygulamaya Dönün",
  onceYou:
    "Oynatma listesi bilgilerinizi girdikten sonra uygulamaya geri dönüp deneyiminize devam edebilirsiniz.",
  refresh: "YENİLE",
  playlist: "Oynatma Listesi",
  bigPlaylist: "OYNATMA LİSTELERİ",
  noLicence: "Lisansınız yok.",
  scanLicence: "Lisans satın almak için tarayın.",
  noPlaylist: "Herhangi bir oynatma listeniz yok",
  privacyBig: "GİZLİLİK MODU",
  scanToAddBig: "OYNATMA LİSTESİ EKLEMEK İÇİN TARAYIN",
  scanToBuyBig: "LİSANS SATIN ALMAK İÇİN TARAYIN",
  orVisit: "veya ziyaret edin",
  andenterdeviceID: "ve bu cihaz kimliğini girin:",
  removePlaylist: "Oynatma Listesini Kaldır",
  wantToRemove: "Kaldırmak istiyor musunuz?",
  cancelBig: "İPTAL",
  loading: "Yükleniyor...",
  enablePMode: "İzlemeye devam etmek için lütfen Gizlilik Modunu etkinleştirin.",
  killSwitchProtecting: "Kill Switch, Gizlilik Modu kapalıyken erişimi engelleyerek gizliliğinizi koruyor.",
  kSwitchProtecionActive: "Kill Switch Koruması Etkin",
  privacyMode: "Gizlilik Modu",
  ok: "TAMAM",

  //Home
  bigLiveTv: "Canlı TV'ler",
  bigMovies: "Filmler",
  bigSeries: "Diziler",
  //Channel-Menu
  noChannels: "Bu oynatma listesinde kanal verisi yok",
  searchChannels: "Kanal Ara",
  tapToPlay: "Video akışını oynatmak için dokunun.",
  categoryEmpty: "Bu kategori boş",
  pinNotSet: "PIN Ayarlanmadı",
  setPinNow: " PIN'inizi şimdi ayarlamak ister misiniz?",
  preview: "ÖN İZLEME",
  liveTv: "Canlı TV",
  addToFav: "Favorilere Ekle",
  removeFromFav: "Favorilerden Çıkar",
  now: "Şimdi:",
  nextPlaying: "Sıradaki:",
  channels: "Kanallar",
  noChannelsFound: "Kanal bulunamadı",

  //Movies
  noMovies: "Bu oynatma listesinde film verisi yok",
  searchMovies: "Film Ara",
  noFavMovies: "Favori film yok",
  //series
  noSeries: "Bu oynatma listesinde dizi verisi yok",
  searchSeries: "Dizi Ara",
  noFavSeries: "Favori dizi yok",
  search: " Ara",
  thereIsProblem: "Şu anda bir sorun var",
  tryAgainLater: "Lütfen daha sonra tekrar deneyin.",
  series: "Diziler",
  movies: "Filmler",
  noSeriesFound: "Dizi bulunamadı",
  noMoviesFound: "Film bulunamadı",
  //entity
  play: "OYNAT",
  playMovie: "Filmi Oynat",
  recommendations: "Öneriler",
  //User Info
  userInfo: "Kullanıcı Bilgisi",
  aboutApp: "Uygulama Hakkında",
  //Userinfo
  account: "Hesap",
  subscriptions: "Abonelikler",
  privacyPilicy: "Gizlilik ve Politika",
  languge: "Dil",
  english: "İngilizce",
  italian: "İtalyanca",
  german: "Almanca",
  spanish: "İspanyolca",
  french: "Fransızca",
  saudiArabia: "Arapça",
  chinese: "Çince",
  greek: "Yunanca",
  turkish: "Türkçe",
  change_pin: "PIN Değiştir",
  kill_switch: "Acil Durdurma Anahtarı",
  device_info: "Cihaz Bilgisi",
  unknown: "Bilinmiyor",

  //headers
  settings: "Ayarlar",
  termsConditions: "Şartlar ve Koşullar",
  home: "Ana Sayfa",

  //license
  scanQrCode: "Oynatma listesi göndermek için QR Kodu Tarayın",
  managePlaylist: "Oynatma Listesini Yönet",
  orVisitt: "Veya ziyaret edin",
  scanToAdd: "Oynatma listesi eklemek için tarayın veya ziyaret edin",

  //device info
  display: "Ekran",
  storage: "Depolama",
  network: "Ağ",
  connection: "Bağlantı",
  macAddress: "MAC Adresi:",
  deviceId: "Cihaz Kimliği:",
  pmInfo: "Gizlilik Modu Bilgisi",
  statusActive: "Durum: Aktif",
  underMaintance: "Durum: Bakımda",
  version: "Sürüm:",
  lastBuildDate: "Son Derleme Tarihi:",
  lastUpdated: "Son Güncelleme: ",

  //kill switch
  enableKillSwitch: "Kill Switch Etkinleştirilsin mi?",
  disableKillSwitch: "Kill Switch Devre Dışı Bırakılsın mı?",
  whenEnabled: "Etkinleştirildiğinde, OrbixPlay YALNIZCA Gizlilik Modu açıkken çalışır.",
  withOrWithoutPM: "OrbixPlay, Gizlilik Modu açık veya kapalı olsun normal şekilde çalışır.",
  extra_privacy_protection: " Ekstra Gizlilik Koruması",
  pmOn: "• Gizlilik Modu AÇIKSA: içerikleri güvenli şekilde yayınlayabilirsiniz",
  killSwitchDescription: "Kill Switch, maksimum gizlilik için ekstra bir koruma katmanı sağlar.",
  pmOff: "• Gizlilik Modu KAPALI ise: uygulama gizliliğinizi korumak için erişimi engeller",
  reenable: "Maksimum güvenlik için istediğiniz zaman yeniden etkinleştirebilirsiniz.",
  cancel: "İptal",
  enable: "Etkinleştir",
  disable: "Devre Dışı Bırak",
  killSwitch: "Kill Switch – Ekstra Gizlilik Koruması",
  ipHidden: "Gizlilik Modunu açtığınızda, IP adresiniz gizlenir ve bağlantınız güvenli bir sistem üzerinden geçer — VPN'in çalışma biçimine benzer şekilde.",
  extraLayer: "Kill Switch ekstra bir koruma katmanıdır: etkinleştirirseniz OrbixPlay yalnızca Gizlilik Modu açıkken çalışır.",
  ifPmOn: "• Gizlilik Modu AÇIKSA: içerikleri güvenli şekilde yayınlayabilirsiniz",
  ifPmOff: "• Gizlilik Modu KAPALI ise: uygulama gizliliğinizi korumak için erişimi engeller",
  recommended: "Maksimum güvenlik isteyen ve koruma olmadan asla yayın yapmak istemeyenler için önerilir.",
  current_status: "Mevcut Durum:",
  pressToDisable: "🛡️ ETKİN - Devre Dışı Bırakmak İçin Basın",
  pressToEnable: "○ DEVRE DIŞI - Etkinleştirmek İçin Basın",
  pressEnter: " Kill Switch ayarını değiştirmek için yukarıdaki butona Enter'a basın",

  //set pin
  pinSetSuccessfully: "PIN Başarıyla Ayarlandı!",
  createPin: "PIN'inizi Oluşturun",
  confirmPin: "PIN'inizi Onaylayın",
  confirmYourPin: "confirmPin: 'PIN'inizi Onaylayın'",
  initializingPin: "PIN kurulumu başlatılıyor...",
  enterCurrentPin: "Mevcut PIN'i Girin",
  enterNewPin: "Yeni PIN'i Girin",
  confirmNewPin: "Yeni PIN'i Onaylayın",
  pinChanged: "PIN Başarıyla Değiştirildi!",
  pinHasChanged: " PIN'iniz başarıyla değiştirildi!",

  //lastones
  playInfo: "Oynatma Listesi Bilgisi",
  playName: "Oynatma Listesi Adı:",
  host: "Sunucu:",
  username: "Kullanıcı Adı:",
  password: "Şifre:",
  packName: "Paket Adı:",
  expireDate: "Son Kullanma Tarihi:",

  //privacyPolicy
  one: "1. İçerik Feragatnamesi: OrbixPlay, dijital deneyiminizi geliştirmek için tasarlanmış bir platformdur. Ancak OrbixPlay'in video içeriği barındırmadığını, sağlamadığını veya dağıtmadığını belirtmek önemlidir. Hizmetimiz dijital yolculuğunuzu desteklemek için yapılandırılmıştır; ancak video materyalinin kullanılabilirliği, kalitesi veya içeriğinden sorumlu değiliz, zira bu konular hizmetlerimizin kapsamı dışındadır.",
  two: "2. Üçüncü Taraf İçeriğe İlişkin Sorumsuzluk: OrbixPlay LLC, uygulamamamız aracılığıyla erişebileceğiniz herhangi bir üçüncü taraf içeriğinden sorumlu değildir. Yasallığı, güvenilirliği veya uygunluğu da dahil olmak üzere harici içerikle etkileşiminiz tamamen kendi sorumluluğunuzdadır.",
  three:
    "3. Yetki Alanı ve Uyumluluk: OrbixPlay LLC, Amerika Birleşik Devletleri yetki alanı altında faaliyet göstermektedir. Kullanıcılar, uygulamayı kullanımlarının tüm yerel, eyalet ve federal yasalara uygun olmasını sağlamakla yükümlüdür.",
  four: "4. Fiyatlandırma Politikası: OrbixPlay'in hizmet fiyatları önceden bildirimde bulunulmaksızın herhangi bir zamanda değişebilir. Bu sözleşmeyi kabul ederek fiyatların değişebileceğini ve bu tür değişikliklerin aboneliğinizin yenilenmesine kadar mevcut hizmetinizi etkilemeyeceğini kabul etmiş olursunuz.",
  five: `5. Garanti Yoktur: OrbixPlay uygulaması ve hizmetleri, zımni ticari elverişlilik, belirli bir amaca uygunluk ve ihlal etmeme garantileri dahil ancak bunlarla sınırlı olmamak üzere, herhangi bir açık veya zımni garanti olmaksızın "olduğu gibi" sunulmaktadır.`,
  six: "6. Şartların Kabulü: Kabul Et'e tıklayarak bu feragaatname şartlarına bağlı olmayı kabul eder ve herhangi bir ihlalin OrbixPlay hizmetlerine erişiminizin sonlandırılmasına yol açabileceğini kabul edersiniz.",
  orbixUserAgreement: "ORBIXPLAY KULLANICI SÖZLEŞMESİ VE FERAGATNAMESİ",
  beforeyouProcc: "Devam etmeden önce lütfen aşağıdaki şartlar ve koşulları okuyun ve kabul edin:",

  //additional
  exitApp: "OrbixPlay'den Çık",
  wantToExit: "OrbixPlay'den çıkmak istediğinizden emin misiniz?",
  Resume: "Devam Et",

  whatsnewinv: "Sürümdeki Yenilikler v",
  whatsnew: "Yenilikler",

  resellerInfiniteDevices: "Bayi Planı: Sınırsız Cihaz",
  resellerInfiniteDevicesDesc: "Aynı çalma listesi artık sınırsız sayıda cihaza kurulabilir — 5 veya 10 değil, ihtiyacınız kadar.",
  thankyouforusingorbixplayenjoythenewfeatures: "OrbixPlay'i kullandığınız için teşekkür ederiz — yeni özelliklerin keyfini çıkarın!",

  instanthomescreen: "İzlemeye Devam Et",
  instanthomescreendesc: "Dizi ve filmlerinize kaldığınız yerden devam edin.",
  turbomoviesearch: "Favoriler Özelliği",
  turbomoviesearchdesc: "Favori içeriklerinizi hızlı ve kolay erişim için kaydedin.",
  lighterondataandbattery: "Geliştirilmiş Oynatıcı Kararlılığı",
  lighterondataandbatterydesc: "Geliştirilmiş oynatma güvenilirliği ve daha akıcı ileri/geri sarma işlemleri.",
  underthehoodfixes: "Arka Plan Düzeltmeleri",
  underthehoodfixesdesc: "Daha iyi bir deneyim için çeşitli hata düzeltmeleri ve performans iyileştirmeleri.",

  proxyMaintenance: 'Proxy Bakımı',
  proxyMaintenanceMessage: 'Proxy sunucusu şu anda bakımda. Lütfen daha sonra tekrar deneyin.',

  playlistInformation: 'Oynatma Listesi Bilgisi',
  playlistExpDate: 'Oynatma Listesi Son Kullanma Tarihi: ',

  select_playlist: "Oynatma Listesi Seç",
  choose_playlist: "İzlemeye başlamak için bir oynatma listesi seçin",
  invalid_line: "Geçersiz Hat",
  expire_date: "Son Kullanma Tarihi:",
  expired: "Süresi Doldu",
  waiting_connection: "Bağlantı bekleniyor...",
  reconnection_attempt: "Yeniden bağlanma denemesi",
  try_again: "Tekrar Dene",
  go_back: "Geri Dön",
  unable_to_resume: "Devam Edilemiyor",
  reconnecting: "Yeniden bağlanıyor...",
  no_internet_connection: "İnternet Bağlantısı Yok",
  please_try_again: "Yayın yeniden başlatılamadı. Lütfen tekrar deneyin.",
  restore_stream: "Yayınınızı geri yüklerken lütfen bekleyin.",
  reconnect_automatically: "Ağınızı kontrol edin, otomatik olarak yeniden bağlanacağız.",
  check_wifi: "WiFi bağlantınızı kontrol edin",
  check_ethernet: "Ethernet / LAN bağlantınızı kontrol edin",
  check_internet: "İnternet bağlantınızı kontrol edin",

  add_playlist_screen: "Oynatma Listesi Ekle",
  add_playlist: "Oynatma listesini manuel ekle",
  playlist_name_required: "Oynatma listesi adı gereklidir",
  m3u_url_required: "M3U oynatma listesi URL'si gereklidir",
  server_url_required: "Sunucu URL'si gereklidir",
  username_required: "Kullanıcı adı gereklidir",
  password_required: "Parola gereklidir",
  orbix_code_required: "Orbix ana bilgisayar kodu gereklidir",
  list_code_required: "Liste kodu gereklidir",
  device_id_required: "Cihaz kimliği gereklidir",
  device_id: "Cihaz Kimliği : ",
  playlist_format: "Oynatma Listesi Formatı",
  m3u: "M3U URL",
  username_password: "Kullanıcı Adı / Parola",
  orbix_code: "Orbix Kodu",
  list_code: "Liste Kodu",
  playListName: "Oynatma Listesi Adı *",
  m3uUrl: "M3U Oynatma Listesi URL'si *",
  server_URL: "Sunucu URL'si *",
  username_req: "Kullanıcı Adı *",
  password_req: "Parola *",
  orbix_code_req: "Orbix Ana Bilgisayar Kodu *",
  list_code_req: "Liste Kodu *",
  addPlaylist: "Oynatma Listesi Ekle",
  adding: "Ekleniyor...",
  my_playlist: "Oynatma Listem",
  username_placeholder: "kullanıcı adı",
  password_placeholder: "••••••••",

  //stream exceptions
  stream_extension: "Yayın Uzantısı",

  //storage_and_data
  storage_and_data: "Depolama ve Veri",

  // ── Parental PIN ──────────────────────────────────────────────────────────
  enter_parental_pin: "Ebeveyn PIN'ini Girin",

  // ── Account / Subscriptions labels ───────────────────────────────────────
  status: "Durum",
  active: "Aktif",
  expiration: "Son Kullanma",
  max_connections: "Maks. Bağlantılar",
  one_device: "1 Cihaz",
  created: "Oluşturulma",

  // ── Storage & Data screen ─────────────────────────────────────────────────
  section_title: "Depolama ve Veri",
  section_subtitle: "Depolanan uygulama verilerini yönet",
  favourites_label: "Favoriler",
  history_label: "İzleme Geçmişi",
  cleared_label: "Temizlendi",
  all_cleared_label: "Hepsi Temizlendi",
  remove_cancel_label: "İptal",
  remove_confirm_label: "Temizle",
  clear_fav_channels_title: "Favori Kanallar",
  clear_fav_channels_subtitle: "Tüm kaydedilmiş kanalları kaldır",
  clear_fav_channels_message: "Tüm favori kanallar temizlensin mi?",
  clear_fav_movies_title: "Favori Filmler",
  clear_fav_movies_subtitle: "Tüm kaydedilmiş filmleri kaldır",
  clear_fav_movies_message: "Tüm favori filmler temizlensin mi?",
  clear_fav_series_title: "Favori Diziler",
  clear_fav_series_subtitle: "Tüm kaydedilmiş dizileri kaldır",
  clear_fav_series_message: "Tüm favori diziler temizlensin mi?",
  clear_continue_watching_movies_title: "İzlemeye Devam Et – Filmler",
  clear_continue_watching_movies_subtitle: "Film izleme ilerlemesini kaldır",
  clear_continue_watching_series_title: "İzlemeye Devam Et – Diziler",
  clear_continue_watching_series_subtitle: "Dizi izleme ilerlemesini kaldır",
  clear_continue_watching_title: "İzlemeye Devam Et",
  clear_continue_watching_message: "İzleme geçmişi temizlensin mi?",
  clear_all_title: "Tüm Verileri Temizle",
  clear_all_message: "Bu tüm favorileri ve izleme geçmişini siler.",

  // ── Stream Extension screen ───────────────────────────────────────────────
  stream_extension_desc: "Canlı yayınların sunucunuzdan nasıl istendiğini seçin.",
  ts_desc: "Standart MPEG-TS akışı",
  m3u8_desc: "HLS uyarlamalı akışı",
  current: "Mevcut",

  // ── Kill Switch modal ─────────────────────────────────────────────────────
  access_restricted: "🛡️ Erişim Kısıtlandı",
  to_access_playlists: "Oynatma listelerine erişmek için:",
  enable_privacy_mode_step: "1. Ana ekrandan Gizlilik Modunu etkinleştirin",
  disable_kill_switch_step: "2. Veya Ayarlar → Kill Switch içinde Kill Switch'i devre dışı bırakın",
  preparingContent: "İçeriğiniz hazırlanıyor",

  // ── Home screen ──────────────────────────────────────────────────────────────
  loading_base: "Yükleniyor",
  live_now: "CANLI YAYIN",
  news: "HABERLER",
  sport: "SPOR",
  kids: "ÇOCUKLAR",

  // ── Series details ───────────────────────────────────────────────────────────
  episode: "Bölüm",
  no_episodes: "Bu sezon için mevcut bölüm bulunmamaktadır.",

  searchForChannels: "Kanal ara...",
  kbSpace: "Boşluk",
  kbCaps: "Büyük Harf",
  pressOkToPlay: "Oynatmak için OK'a basın",
  live: "Canlı",
};

export default dict;